const cleanCode = (code) => code.trim().split('.').join('').split('-').join('').toUpperCase();

const packageCodes = (codeValues, codesystemFunc) => {
    if (!codeValues?.trim()) {
        return [];
    }
    return codeValues.split(',').map((code) => {
        const cleanedCode = cleanCode(code);
        return { codesystem: codesystemFunc(cleanedCode), code: cleanedCode };
    });
};

export const packageDxOidForHttp = (oid, description, codeValues) => {
    const codes = packageCodes(codeValues, (_code) => 'ICD10');
    return {
        oid,
        description,
        codes,
    };
};

const inferServiceCodesystem = (code) => {
    if (code.length === 11) {
        return 'NDC';
    }
    return 'HCPCS';
};

export const packageServiceOidForHttp = ({
    oid,
    description,
    genericProductDescription,
    brandProductDescription,
    parentProductService,
    gpi,
    intake,
    codeValues,
}) => {
    const codes = packageCodes(codeValues, inferServiceCodesystem);
    return {
        oid,
        description,
        generic_product_description: genericProductDescription,
        brand_product_description: brandProductDescription,
        parent_product_service: parentProductService,
        gpi,
        intake,
        codes,
    };
};

export const formatCodesForDisplay = (codes) => codes.map((code) => code.code).join(',');

export const getOidSelector = (oidList) => oidList.map((oid) => ({ name: oid.oid }));
